import React from 'react';

export default function NoData() {
  return (
    <div className="py-5 border-bottom w-100 text-center">
      <div className="mb-4">There are no records to display.</div>
    </div>
  );
}
